// src/components/sections/WebinarsListSection.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import { formatDateTime, isFutureDate } from '../../utils/formatDate.js'
import { LazyImage } from '../common/LazyImage.jsx'
import EmptyState from '../common/EmptyState.jsx'
// SkeletonCard removed to better match v1 UI – logic is same (just UI)

export default function WebinarsListSection({ webinars, loading, limit }) {
  // LOADING – same behavior, different UI
  if (loading) {
    return (
      <div className="webinar-grid">
        {[...Array(limit || 2)].map((_, i) => (
          <div key={i} className="webinar-card">
            <div className="card-image">
              <div className="w-full h-full bg-black-200 animate-pulse" />
            </div>
            <div className="card-content">
              <div className="h-4 bg-black-200 rounded w-2/3 mb-3" />
              <div className="h-3 bg-black-200 rounded w-full mb-2" />
              <div className="h-3 bg-black-200 rounded w-3/4 mb-6" />
              <div className="speaker-row skeleton-speaker" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  // EMPTY – same as v2
  if (!webinars || webinars.length === 0) {
    return (
      <EmptyState
        title="No Webinars Scheduled"
        message="Check back later for upcoming webinars and events."
      />
    )
  }

  const displayWebinars = limit ? webinars.slice(0, limit) : webinars

  return (
    <div className="webinar-grid">
      {displayWebinars.map((webinar, index) => (
        <div
          key={webinar._id}
          className="webinar-card"
        >
          {/* Image */}
          <div className="card-image">
            <LazyImage
              src={webinar.hero?.imageUrl}
              alt={webinar.title}
              className="w-full h-full object-cover"
              placeholder={
                <div className="w-full h-full bg-black-200 flex items-center justify-center">
                  <span className="text-gray-400">Loading...</span>
                </div>
              }
            />

            {/* Featured / Upcoming badges – same logic as v2 */}
            {webinar.isFeatured && (
              <div className="featured-badge">
                Featured
              </div>
            )}
            {/* {isFutureDate(webinar.dateTime) && (
              <div className="upcoming-badge">
                Upcoming
              </div>
            )} */}
          </div>

          {/* Content */}
          <div className="card-content">
            {/* Meta row (date + duration) – logic same as v2 */}


            <h3>{webinar.title}</h3>

            <p className="subheading">
              {webinar.hero?.subheading}
            </p>

            <div className="meta-row">
              <span>{formatDateTime(webinar.dateTime)}</span>
              <span className="dot">•</span>
              <span>{webinar.duration}</span>
            </div>

            {/* Speakers – same logic, UI closer to v1 */}
            {/* {webinar.speakers && webinar.speakers.length > 0 && (
              <div className="speakers-block">
                <p className="speakers-label">Speakers</p>
                <div className="speakers-avatars">
                  {webinar.speakers.map((speaker, index) => (
                    <div
                      key={index}
                      className="speaker-avatar"
                    >
                      <LazyImage
                        src={speaker.imageUrl}
                        alt={speaker.name}
                        className="w-8 h-8 rounded-full"
                        placeholder={
                          <div className="w-8 h-8 bg-black-200 rounded-full" />
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            )} */}

            {/* Bottom row – keeps v2 behavior (Register vs Recording + Learn More) */}
            <div className="speaker-row">
              <div className="speaker-info">
                {/* You can surface first speaker's name/role here if you want */}
                {webinar.speaker && (
                  <div>
                    <span className="speaker-name">
                      {webinar.speaker?.name}
                    </span>
                    {webinar.speaker.companyPosition && (
                      <span className="speaker-desc">
                        {webinar.speaker.companyPosition}
                      </span>
                    )}
                  </div>
                )}
              </div>

              <div className="speaker-actions">
                {isFutureDate(webinar.dateTime) ? (
                  <Link
                    to={`/webinars/${webinar.slug}`}
                    className="register-btn"
                  >
                    Register Now
                  </Link>
                ) : (
                  <span className="recording-label">
                    Recording Available
                  </span>
                )}

                <Link
                  to={`/webinars/${webinar.slug}`}
                  className="learn-more-link"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
